import React from 'react';
import {GithubPicker} from 'react-color';

import InputField from './InputField';

export default class ColorPicker extends React.Component {
    state = {
        picker: false
    };

    /**
     * @method handleShowPicker
     */
    handleShowPicker = () => {
        this.setState({
            picker: true
        });
    };

    /**
     * @method handleShowPicker
     */
    handleHidePicker = (event) => {
        this.setState({
            picker: false
        });
    };

    /**
     * @method handleChange
     * @param {object} c
     * @param {Event} e
     */
    handleChange = (c, e) => {
        this.props.onChange(c.hex);

        this.handleHidePicker(e);
    };

    /**
     * @method render
     * @return {*}
     */
    render() {
        const {picker} = this.state;
        const {value, disabled} = this.props;

        return (
            <React.Fragment>
                <div className="flex rounded-md shadow-sm">
                    <span
                        className="inline-flex items-center px-6 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 sm:text-sm"
                        style={{backgroundColor: value}}
                    />

                    <InputField
                        containerClassName="flex-1"
                        className="rounded-l-none"
                        value={value}
                        disabled={disabled}
                        onFocus={this.handleShowPicker}
                    />
                </div>

                {picker && (
                    <div className="z-10 fixed">
                        <GithubPicker

                            onChange={this.handleChange}
                        />
                    </div>
                )}
            </React.Fragment>
        );
    }
}
